import type { TOC } from '@ember/component/template-only';
import { LinkTo } from '@ember/routing';
import isActive from 'ember-router-helpers/helpers/is-active';

export interface TioPageTabsTabSignature {
  Args: {
    label: string;
    route: string;
    query?: Record<string, unknown>;
  };
  Element: HTMLLIElement;
}

const TioPageTabsTabComponent: TOC<TioPageTabsTabSignature> = <template>
  <li
    class="px-2 py-2 md:px-4 md:py-3 font-semibold uppercase tracking-wide border-b border-gray-200 border-b-4
      {{if (isActive @route) ' text-midnight border-midnight' ' text-gray-500 border-transparent'}}
      "
    ...attributes
  >
    <LinkTo @route={{@route}}>
      {{@label}}
    </LinkTo>
  </li>
</template>;

export default TioPageTabsTabComponent;
